import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {
    PageErrorComponent,
    PageLogoutComponent,
    PageNoAccessComponent,
    PageProjectDetailsComponent,
    PageProjectsComponent
} from '../pages';

import {UserGuard, UserRedirectGuard, UserRoleGuard} from '../guards';
import {UserRoles} from '../enums';
import {MsAuthGuard} from '../module/ms-auth';

const routes: Routes = [{
    path: '',
    component: PageNoAccessComponent,
    pathMatch: 'full',
    canActivate: [MsAuthGuard, UserGuard, UserRedirectGuard],
    data: {
        userRedirects: [{
            roles: [
                UserRoles.PIT_USER
            ],
            url: '/projecten'
        }, {
            roles: [],
            url: '/no-access'
        }]
    }
}, {
    path: 'no-access',
    component: PageNoAccessComponent,
    data: {
        menuVisible: true
    }
}, {
    path: 'error',
    canActivate: [UserRedirectGuard],
    data: {
        userRedirects: [{
            roles: [
                UserRoles.PIT_USER
            ],
            url: '/'
        }],
        menuVisible: true
    },
    component: PageErrorComponent
}, {
    path: 'projecten',
    component: PageProjectsComponent,
    canActivate: [MsAuthGuard, UserGuard, UserRoleGuard],
    data: {
        menuVisible: true,
        roles: [
            UserRoles.PIT_USER
        ]
    }
}, {
    path: 'projecten_all',
    component: PageProjectsComponent,
    canActivate: [MsAuthGuard, UserGuard, UserRoleGuard],
    data: {
        menuVisible: true,
        roles: [
            UserRoles.PIT_USER
        ]
    }
}, {
    path: 'logout',
    component: PageLogoutComponent,
    data: {
        menuVisible: true
    }
}, {
    path: 'project/:projectId',
    canActivate: [MsAuthGuard, UserGuard, UserRoleGuard],
    component: PageProjectDetailsComponent,
    data: {
        menuVisible: false,
        roles: [
            UserRoles.PIT_USER
        ]
    }
}];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        useHash: false,
        anchorScrolling: 'enabled'
    })],
    exports: [RouterModule]
})

export class AppRoutingModule {}
